module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Pause_16"],"path":[{"$":{"d":"M7,13H4V3H7ZM12,3H9V13h3Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Pause_16.svg
// module id = uhlb
// module chunks = 1